export const EthereumIcon = () => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g clipPath='url(#clip0_3386_32769)'>
      <mask
        id='mask0_3386_32769'
        style={{ maskType: 'luminance' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='24'
        height='24'
      >
        <path d='M0 0H24V24H0V0Z' fill='white' />
      </mask>
      <g mask='url(#mask0_3386_32769)'>
        <path d='M12 4V9.912L17 12.149L12 4Z' fill='#8FFCF3' />
        <path d='M12 4L7 12.148L12 9.913V4Z' fill='#CABCF8' />
        <path d='M12 15.9801V20.0001L17 13.0801L12 15.9801Z' fill='#CBA7F5' />
        <path d='M12 20.0001V15.9801L7 13.0801L12 20.0001Z' fill='#74A0F3' />
        <path d='M12 15.0491L17 12.1491L12 9.91309V15.0491Z' fill='#CBA7F5' />
        <path d='M7 12.1491L12 15.0491V9.91309L7 12.1491Z' fill='#74A0F3' />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M12 15.048L7 12.148L12 4L17 12.148L12 15.048ZM7.33 11.912L11.918 4.437V9.872L7.33 11.912ZM7.262 12.116L11.918 10.048V14.816L7.262 12.116ZM12.078 10.048V14.816L16.731 12.116L12.078 10.048ZM12.078 9.872L16.666 11.912L12.078 4.437V9.872Z'
          fill='#202699'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M12 15.9172L7 13.0772L12 20.0002L17 13.0762L12 15.9172ZM7.56 13.5762L11.92 16.0562V19.6162L7.56 13.5762ZM12.079 16.0562V19.6162L16.439 13.5762L12.079 16.0562Z'
          fill='#202699'
        />
      </g>
    </g>
    <defs>
      <clipPath id='clip0_3386_32769'>
        <rect width='24' height='24' fill='white' />
      </clipPath>
    </defs>
  </svg>
);
